import { CoinIcon } from "@/components/Brand";
import { fmt } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function GameHeader({ game }) {
  return (
    <div className="relative h-28 bg-cover bg-center shrink-0" style={{ backgroundImage: `url(${game.image})` }}>
      <div className="absolute inset-0 bg-gradient-to-t from-[#151A22] via-[#151A22]/40 to-transparent" />
      <div className="absolute bottom-3 left-5">
        <h3 className="font-display text-2xl font-black">{game.name}</h3>
        <div className="text-xs text-gray-300">{game.provider} · RTP {game.rtp}%</div>
      </div>
    </div>
  );
}

export function BetControls({ bet, setBet, disabled }) {
  const { currency, user } = useApp();
  const real = currency !== "gc";
  const MIN = real ? 0.1 : 100;
  const MAX = real ? 10000 : 10000000;
  const step = real ? 0.5 : 100;
  const clamp = (v) => Math.min(MAX, Math.max(MIN, Math.round(v * 100) / 100));
  const adj = (f) => setBet((b) => clamp(f(b)));
  const quick = real ? [1, 10, 100, 1000] : [500, 5000, 50000, 500000];
  return (
    <div data-testid="bet-controls">
      <div className="flex items-center justify-between text-sm text-gray-400 mb-1.5">
        <span>Bet amount</span>
        <span className="flex items-center gap-1"><CoinIcon cur={currency} size={14} />{fmt(user?.[currency] ?? 0, currency)}</span>
      </div>
      <div className="flex items-stretch gap-2">
        <button data-testid="bet-minus" disabled={disabled} onClick={() => adj((b) => b - step)} className="w-11 rounded-xl bg-[#1F2633] font-display text-xl font-black disabled:opacity-40">−</button>
        <div className="flex-1 flex items-center gap-2 rounded-xl bg-[#0B0E14] border border-white/10 px-3">
          <CoinIcon cur={currency} size={18} />
          <input
            data-testid="bet-input"
            type="number"
            inputMode="decimal"
            disabled={disabled}
            value={bet}
            min={MIN}
            max={MAX}
            step={real ? 0.1 : 100}
            onChange={(e) => setBet(e.target.value === "" ? "" : Number(e.target.value))}
            onBlur={(e) => setBet(clamp(Number(e.target.value) || MIN))}
            className="flex-1 w-0 bg-transparent py-3 font-display text-lg font-bold outline-none"
          />
        </div>
        <button data-testid="bet-half" disabled={disabled} onClick={() => adj((b) => b / 2)} className="px-3 rounded-xl bg-[#1F2633] text-sm font-bold disabled:opacity-40">½</button>
        <button data-testid="bet-double" disabled={disabled} onClick={() => adj((b) => b * 2)} className="px-3 rounded-xl bg-[#1F2633] text-sm font-bold disabled:opacity-40">2×</button>
      </div>
      <div className="mt-2 grid grid-cols-4 gap-2">
        {quick.map((q) => (
          <button key={q} data-testid={`bet-quick-${q}`} disabled={disabled} onClick={() => setBet(clamp(q))} className="rounded-lg bg-[#1F2633] py-1.5 text-xs font-bold text-gray-300 hover:text-white disabled:opacity-40 transition-colors">{fmt(q, currency)}</button>
        ))}
      </div>
      <div className="mt-1.5 text-[11px] text-gray-500">Min {fmt(MIN, currency)} · Max {fmt(MAX, currency)} {currency.toUpperCase()}</div>
    </div>
  );
}
